import { formatDateToString } from '../formatDateToString'
import { formatHourToString } from '../formatHourToString'

export function formatDateAndHourToString(parameterDate?: Date | string, defaultEmptyString = '') {
  if (!parameterDate) return defaultEmptyString

  const date = formatDateToString(parameterDate)
  const hour = formatHourToString(parameterDate)

  if (!date) return 'data não encontrada'

  return `${date} às ${hour}`
}
